export const MUTED_TEXT = { root: { color: '#605e5c' } }
